class Accordion {
  #animation = null;

  constructor(details) {
    this.details = details;
    this.answer = details.querySelector('.accordion-detail__content');
    details.querySelector('summary').addEventListener('click', (e) => this.#onToggle(e));
  }

  #onToggle(e) {
    e.preventDefault();
    if (this.#animation) this.#animation.cancel();
    this.details.open ? this.#collapse() : this.#expand();
  }

  #expand() {
    this.details.open = true;
    this.#animation = this.answer.animate(
      [{ height: '0px' }, { height: `${this.answer.scrollHeight}px` }],
      { duration: 350, easing: 'ease-in-out' }
    );
    this.#animation.onfinish = () => (this.#animation = null);
  }

  #collapse() {
    this.#animation = this.answer.animate(
      [{ height: `${this.answer.scrollHeight}px` }, { height: '0px' }],
      { duration: 350, easing: 'ease-in-out', fill: 'forwards' }
    );
    this.#animation.onfinish = () => {
      this.details.open = false;
      this.#animation.cancel();
      this.#animation = null;
    };
  }

  static init(selector = '.accordion-detail:not(.anatomy-accordion)') {
    document.querySelectorAll(selector).forEach((el) => new Accordion(el));
  }
}

class AnatomyAccordion {
  #animation = null;
  #isOpen = true;

  constructor(details) {
    this.details = details;
    this.answer = details.querySelector('.feature-item__content-inner > p');
    this.hasBenefit = !!details.querySelector('.feature-item__benefit');
    details.querySelector('summary').addEventListener('click', (e) => this.#onToggle(e));
  }

  #onToggle(e) {
    e.preventDefault();
    if (this.#animation) this.#animation.cancel();
    this.#isOpen ? this.#collapse() : this.#expand();
  }

  #expand() {
    this.#isOpen = true;
    this.details.classList.remove('is-closed');
    if (!this.answer) return;
    const margin = this.hasBenefit ? '16px' : '0px';
    this.#animation = this.answer.animate(
      [{ height: '0px', marginTop: '0px' }, { height: `${this.answer.scrollHeight}px`, marginTop: margin }],
      { duration: 350, easing: 'ease-in-out' }
    );
    this.#animation.onfinish = () => {
      this.answer.style.height = '';
      this.answer.style.marginTop = '';
      this.#animation = null;
    };
  }

  #collapse() {
    this.#isOpen = false;
    this.details.classList.add('is-closed');
    if (!this.answer) return;
    const margin = this.hasBenefit ? '16px' : '0px';
    this.#animation = this.answer.animate(
      [{ height: `${this.answer.scrollHeight}px`, marginTop: margin }, { height: '0px', marginTop: '0px' }],
      { duration: 350, easing: 'ease-in-out' }
    );
    this.#animation.onfinish = () => {
      this.answer.style.height = '0px';
      this.answer.style.marginTop = '0px';
      this.#animation = null;
    };
  }

  static init() {
    document.querySelectorAll('.anatomy-accordion').forEach((el) => new AnatomyAccordion(el));
  }
}

Accordion.init();
AnatomyAccordion.init();